import {
  AutopilotSearchDesignStep,
  CuratedSearchDesignTextOnlyStep_AutopilotSearchDesignTextOnlyStepFragmentDoc,
} from "../../../__generated__/graphql";
import classNames from "classnames";
import {
  makeFragmentData,
  useFragment as getFragmentData,
} from "../../../__generated__";
import CuratedSearchDesignTextOnlyStep from "./CuratedSearchDesignStep/CuratedSearchDesignTextOnlyStep";

interface ICuratedSearchDesignLsnSteps {
  processedSteps: AutopilotSearchDesignStep[];
  isComplete: boolean;
}

const CuratedSearchDesignLsnSteps = ({
  processedSteps,
}: ICuratedSearchDesignLsnSteps) => {
  const lsnFilterSteps = processedSteps.filter(
    (step) => step.__typename === "AutopilotSearchDesignLsnFiltersStep",
  );

  const generalTextSteps = processedSteps.filter(
    (step) =>
      step.__typename === "AutopilotSearchDesignTextOnlyStep" &&
      (!("jobId" in step) || !step.jobId),
  );

  if (lsnFilterSteps.length === 0 && generalTextSteps.length === 0) {
    return null;
  }

  return (
    <div className={classNames("space-y-4", "mb-6")}>
      {generalTextSteps.map((step, idx, arr) => {
        if (step.__typename !== "AutopilotSearchDesignTextOnlyStep") {
          return null;
        }
        const isCurrentStep =
          idx === arr.length - 1 && lsnFilterSteps.length === 0;

        return (
          <CuratedSearchDesignTextOnlyStep
            key={`general-${idx}`}
            data={getFragmentData(
              CuratedSearchDesignTextOnlyStep_AutopilotSearchDesignTextOnlyStepFragmentDoc,
              makeFragmentData(
                step,
                CuratedSearchDesignTextOnlyStep_AutopilotSearchDesignTextOnlyStepFragmentDoc,
              ),
            )}
            isCurrentStep={isCurrentStep}
          />
        );
      })}
    </div>
  );
};

export default CuratedSearchDesignLsnSteps;
